require('../mixins/disable_frame_links.js');
require('../mixins/initialize_signup_forms.js');
require('./preview_controls.js');

(function(){
  var proctor = null;

  window.didLoadPreview = function(){
    this.onload = function(){ window.didWritePreview.call(this); }
    Em.run.schedule('afterRender', proctor, 'replaceBody', this);
  };

  window.didWritePreview = function(){
    this.onload = '';
    Em.run.schedule('afterRender', proctor, 'fixAnchors', this);
    if ( Pegasus.loadedTemplate().get('underscore_type') !== 'email_template' ) {
      Em.run.schedule('afterRender', proctor, 'initializeForms', this);
      Em.run.schedule('afterRender', proctor, 'initializeIFrames', this);
    }
  };

  window.formSubmissionCallback = function(){
    window.alert( Em.I18n.t('g.form_success') );
  };

  Pegasus.TemplatePreviewView = Ember.View.extend( Pegasus.DisableFrameLinks, Pegasus.InitializeSignupForms, {
    frameSelector: '[name="preview-iframe"]',
    classNames: ['preview-iframe-container'],
    classNameBindings: ['controller.templateType'],
    templateName: 'preview_layout',
    previewControls: Pegasus.PreviewControlsView,
    willDestroyElement: function(){
      this.unbindResize();
      this._super();
    },
    bindResize: function(){
      $(window).bind('resize.' +this.get('elementId'), function(){
        Ember.run.cancel( this.resizeTimer );
        this.resizeTimer = Ember.run.later( this, 'resize', 100);
      }.bind(this));
    },
    unbindResize: function(){
      $(window).unbind('resize.'+this.get('elementId') );
    },
    resize: function(){
      var iframe;

      if( this.$() ){
        iframe = this.$(this.get('frameSelector'));
        iframe.css({
          height: $( window ).height() - 62
        });
      }
    },
    replaceBody: function(frame){
      if ( !this.get('controller.frameSrc') ) {
        var doc = frame.contentWindow.document;
        doc.open();
        doc.write(this.get('controller.message'));
        doc.close();
      }

      Em.run.scheduleOnce('afterRender', this, 'resize');

      Em.run.next( this.$('.tilted'), 'removeClass', 'tilted');
    },

    init: function(){
      didFinishLoading = false;
      this._super();
      proctor = this;
    },

    didChangeActiveType: function(){
      if( this.get('state')!=='inDOM'){ return; }

      // It would be much more simple to just `.hide()`
      // these, but webkit struggles to properly flex
      // the display height when an element's display attribute
      // is ever set to 'none'.
      //
      // Instead we will move them all well off the page
      $('#tablet, #phone, #desktop').css({
        position: 'absolute',
        top: -9e4,
        left: -9e4
      });
      $('#' + this.get('controller.activeType') ).css({
        position: '',
        top: '',
        left: ''
      });
    }.observes('controller.activeType'),

    didInsertElement: function(){
      this._super();
      //this.resize();
      this.bindResize();
      this.didChangeActiveType();
      // trigger X rotation from initial set in CSS
    }
  });
})();
